import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import FontAwesomeIcon from './assets/fontawesome/fontawesome'
import { globalMixin } from './utils/mixin.js';
import store from './utils/store';
import DatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import './assets/sass/main.scss';

const app = createApp(App);
app.use(store);
app.mixin(globalMixin);
app.component('DatePicker', DatePicker);
app.component('font-awesome-icon', FontAwesomeIcon);

app.use(router).mount('#app');